<div class="pnl-homepage">
  <app-homepage-template></app-homepage-template>
</div>